module.exports = __webpack_public_path__ + "media/images/flags/32/Laos-e8ae6a2e10f18a060e3119eb48a5ea67.png";